export const ACCOUNT_ENDPOINTS = {
  USER_ROLE: 'Users/currentUserRole',
}
